const resolveDomain = (): { api: string, host: string, adminHost: string, stripe: string, mixpanel: string } => {
  const hostname = window.location.hostname;

  if (hostname === 'localhost') {
    return withLogger({
      api: 'http://localhost:9080/api',
      host: 'http://localhost:9080',
      adminHost: 'http://localhost:9081',
      stripe: process.env.REACT_APP_STRIPE_TEST as string,
      mixpanel: process.env.REACT_APP_MIXPANEL_TEST as string,
    });
  }

  const isSandbox = hostname === 'app.test-app-grammarflip.us-east-2.elasticbeanstalk.com';

  if (isSandbox) {
    return withLogger({
      api: 'https://app.test-app-grammarflip.us-east-2.elasticbeanstalk.com/api',
      host: 'https://app.test-app-grammarflip.us-east-2.elasticbeanstalk.com',
      adminHost: 'https://admin.test-app-grammarflip.us-east-2.elasticbeanstalk.com',
      stripe: process.env.REACT_APP_STRIPE_TEST as string,
      mixpanel: process.env.REACT_APP_MIXPANEL_TEST as string,
    });
  }

  const hostProd = process.env.REACT_APP_HOST_PROD as string;

  return withLogger({
    api: `${hostProd}/api`,
    host: hostProd,
    adminHost: hostProd.replace('//app.', '//admin.'),
    stripe: process.env.REACT_APP_STRIPE_PROD as string,
    mixpanel: process.env.REACT_APP_MIXPANEL_PROD as string,
  });
};

const withLogger = (result: any) => {
  // console.log(result);

  return result;
}

export default resolveDomain;
